"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colors_1 = require("../../generated/colors");
var SimpleArrowDown_1 = __importDefault(require("../../generated/icons/general/SimpleArrowDown"));
var global_1 = require("../../global");
exports.MuiSelect = {
    defaultProps: {
        sx: {
            "& .MuiNativeSelect-select": {
                fontSize: "1rem",
            },
        },
        IconComponent: function (props) { return ((0, jsx_runtime_1.jsx)(SimpleArrowDown_1.default, __assign({ width: "24px", height: "24px" }, props), void 0)); },
        MenuProps: {
            PaperProps: {
                sx: {
                    borderRadius: "1.5rem",
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.3),\n                  0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
                },
            },
            MenuListProps: {
                sx: {
                    "& .MuiMenuItem-root": {
                        paddingLeft: 4,
                        fontSize: "1rem",
                        fontWeight: global_1.fontWeight.bold,
                        height: "2rem",
                        minHeight: "2rem",
                        lineHeight: "1.5rem",
                        margin: 0,
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        "&:hover, &:focus": {
                            bgcolor: colors_1.colors.Mint25,
                        },
                        "&[aria-selected=true]": {
                            bgcolor: colors_1.colors.Mint50,
                            " &:focus": {
                                bgcolor: colors_1.colors.Mint25,
                            },
                        },
                    },
                },
            },
        },
    },
    styleOverrides: {
        select: {
            minHeight: "1rem",
            fontSize: "1rem",
        },
        icon: {
            color: colors_1.colors.Text,
            right: "10px",
        },
    },
};
//# sourceMappingURL=select.js.map